import {
  SHOW_CREATE_TSV_MODAL,
  HIDE_CREATE_TSV_MODAL,
  CREATE_TSV_REQUEST,
} from '../constants/action-types';

export const showCreateTsvModal = () => ({
  type: SHOW_CREATE_TSV_MODAL,
});

export const hideCreateTsvModal = () => ({
  type: HIDE_CREATE_TSV_MODAL,
});

export const requestCreateTsv = (file, name) => ({
  type: CREATE_TSV_REQUEST,
  file,
  name,
});
